<template>
  <div class="container mt-md-5 col-md-6 p-4">
    <div class="row">
      <h2 class="text-uppercase">{{ $t('gameSelection.title') }}</h2>
      <div v-if="games.length > 0" class="d-grid overflow-scroll">
        <div class="row g-0 column-gap-1 align-items-center" v-for="game in games" :key="game.id">
          <button :key="game.id"
                   @click="loadGame(game.id)" class="col-10 btn m-0 p-2 my-2" :class="game.status ? 'btn-secondary' : 'btn-bb5-yellow'">
            <b class="d-block">{{ game.name }}</b>
            <small>{{ game.score }}</small> | <small>Inning: {{ game.inning }}</small> | <small>{{ formatDate(game.id) }}</small>
          </button>
          <button class="col btn btn-danger m-0 py-2" @click="deleteGame(game.id)">X</button>
        </div>
      </div>
      <div v-else>
        <p>{{ $t('gameSelection.noGames') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import { loadAllScoreResult, deleteGame } from '@/services/indexedDB';

export default {
  name: 'GameSelection',
  data() {
    return {
      games: [],
    };
  },
  async mounted() {
    this.games = await loadAllScoreResult();
  },
  methods: {
    ...mapActions(['setGame', 'continueGame']),
    async loadGame(gameId) {
      localStorage.setItem('currentgame', gameId);
      await this.continueGame(
          gameId
      );
      this.$router.push('/game');
    },
    async deleteGame(gameId) {
      await deleteGame(
          gameId
      );
      this.games = this.games.filter(game => game.id !== gameId);
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      // Formatierung
      return date.toLocaleString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

  }
};
</script>

<style scoped>
</style>
